import { useEffect, useState } from "react";
import SyIcon from "../../components/sy-icon";
import OrbInput from "../orb-input";

const OrbMultiMail = (props: any) => {
  const {
    chipValue,
    value,
    setValue,
    clearErrors,
    setError,
    onChange,
    errorMessage,
    type,
    placeholder,
    label,
    onMailSelect,
  } = props;
  const [emailArray, setEmailArray] = useState<any>([]);

  useEffect(() => {
    onMailSelect(emailArray);
  }, [emailArray]);


  useEffect(() => {
setEmailArray(chipValue)
  }, [chipValue]);
  
  const onClickEnter = (val: any) => {
    const alreadyExitMail: any = emailArray?.filter(
      (value: any) => value.email === val
    );

    if (!errorMessage) {
      if (!alreadyExitMail.length) {
        const a = {
          email: val,
          valid: true,
        };
        setEmailArray((prev: any) => [...prev, a]);
      } 
      
      setValue("email", '');
    }

  };

  const onCloseClick = (index: any) => {
    const newArray = [...emailArray];
    newArray.splice(index, 1);
    setEmailArray(newArray);
  };

  return (
    <>
      <OrbInput
        id={"email"}
        placeholder={placeholder}
        type={type}
        label={label}
        errorMessage={errorMessage}
        keyClick={","}
        onClickEnter={onClickEnter}
        value={value}
        onChange={onChange}
        // ref={commentInputRef}
        // placeholder={placeholder}
        // type={type}
        // label={label}
        // id={"email"}
        // keyClick={","}
        // onChange={onValChange}
        // onClickEnter={onClickEnter}
        // onChangeBlur={onChangeBlur}
        // errorMessage={errorMessage}
      />

      <div className="mb-3 mt-2 d-flex flex-wrap">
        {emailArray.map((data: any, index: any) => {
          return (
            <div
              className={`mb-1 p-1 me-1 ${
                data.valid ? "bg-white text-dark" : "bg-danger text-white"
              } rounded   d-flex align-items-center`}
            >
              <span className=" font-10  px-1 mohave">{data.email}</span>
              <SyIcon
                name="close"
                iconType="symbols"
                iconStyle="outlined"
                className={`pointer font-10 `}
                onClick={() => onCloseClick(index)}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default OrbMultiMail;
